import React, { useContext } from "react";
import { MdOutlinePalette as PaletteIcon } from "react-icons/md";
import styles from "./GradientSelector.module.scss";
import {
    Menu,
    MenuItem,
    MenuItems,
    MenuButton,
} from "@headlessui/react";
import { ThemeContext } from "src/contexts/ThemeProvider";
import gradientThemes from "./themes";

interface Props { }

const GradientSelector: React.FC<Props> = () => {
    const themeContext = useContext(ThemeContext);

    return (
        <Menu as="div">
            <MenuButton className={styles.selector}>
                <PaletteIcon className={styles.icon} />
            </MenuButton>
            <MenuItems
                anchor="top end"
                className={styles.menuList}
                transition
            >
                {gradientThemes.map((theme, i) => (
                    <MenuItem key={theme.name}>
                        {({ focus }) => (
                            <button
                                className={`${styles.menuItem} ${focus ? styles.focus : ""
                                    }`}
                                onClick={() =>
                                    themeContext.changeParticleThemeIndex(i)
                                }
                                disabled={themeContext.particleThemeIndex === i}
                                style={{

                                    textAlign: "left",
                                }}
                            >
                                {theme.name}
                            </button>
                        )}
                    </MenuItem>
                ))}
            </MenuItems>
        </Menu>
    );
};

export default GradientSelector;
